import React from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Row,
  Button,
} from "reactstrap";


const Header = (props) => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto" className="d-none d-sm-block">
        <h3>My Workout Sessions</h3>
      </Col>

      <Col xs="auto" className="ml-auto text-right mt-n1">
      <Button color="primary" className="shadow-sm mr-1" tag={Link} to="/workouts/All">
         See Workouts
      </Button>

      </Col>
    </Row>
  );
};

export default Header;
